import { FC, useState } from 'react';
import styles from './compare-credit-services.module.scss';
import { useTranslation } from 'react-i18next';
import Field from '../../components/shared/Field/Field';
import StyledCheckbox from '../../components/shared/StyledCheckbox/StyledCheckbox';
import { validateEmail } from '../../util';
import BtButton from '../bt-button/bt-button';
import serviceCredibility from '../../services/service-credibility';
import axios from "axios";

type ErrorMessage = {
  i18nKey: string;
  description: string;
}

type Props = {
  onCancel: (e: React.MouseEvent) => void;
  onSubscribe: (email: string, apiKey: string) => void;
}

export const TicSignup: FC<Props> = ({onCancel, onSubscribe}) => {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'supplierControls.compareCreditServices.ticSignup' });
  const [agreeToTermsError, setAgreeToTermsError] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const [emailError, setEmailError] = useState<string>('');
  const emptyEmailErrorMessage = t('validate.email', 'Du måste ange en e-postadress');
  const [agreed, setAgreed] = useState<Boolean>(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessage|null>();

  const onSubmit = async (e: React.MouseEvent) => {
    e.stopPropagation();
    const emailErrorMessage = email ? validateEmail(email) : emptyEmailErrorMessage;
    setEmailError(emailErrorMessage);
    setAgreeToTermsError(!agreed);
    if (agreed && !emailErrorMessage) {
      console.log('submitting');
      let resp;
      try {
        resp = await serviceCredibility.signupTicCustomer(email);
      } catch (err) {
        console.log('Error signing up customer at Tic', err);
        if (axios.isAxiosError(err) && err.response?.data?.error) {
          setErrorMessage(err.response.data.error);
        }
      }
      if (resp?.apiKey) {
        console.log('Signed up customer at Tic', resp);
        onSubscribe(email, resp.apiKey);
      } else {
        console.log('Error signing up customer at Tic. Did not get apiKey.');
        setErrorMessage({ i18nKey: 'generic', description: 'Error signing up customer at Tic' });
      }
    }
  };

  const onAgreeToTermsChange = (value: boolean) => {
    console.log('setAgreed(value))', value);
    setAgreeToTermsError(false);
    setAgreed(value);
  };

  const onEmailChange = (value: string) => {
    setEmail(value);
    console.log('validateEmail(value))', validateEmail(value));
    if (!validateEmail(value)) setEmailError('');
  };

  return (
    <div>
      <div className={styles.signup}>
        { errorMessage ? <>
          <h3>{ t('error.heading', 'Något gick fel!') }</h3>
          <div className={styles.error}>{t(`error.${errorMessage.i18nKey}`, errorMessage.description)}</div>
        </> : <>
          <h3>{ t('heading', 'Signa upp för Tic') }</h3>
          <Field
            value={email}
            onChange={onEmailChange}
            required
            label={t('email', 'E-postadress')}
            errorMessage={emailError}
          />
          <div className={styles.agreement}>
            <StyledCheckbox
              checked={agreed}
              onChange={() => onAgreeToTermsChange(!agreed)}
              className={styles.checkbox}
              error={agreeToTermsError}
            />
            <p>
              <span>Jag godkänner <b>användarvillkor och avtal</b> enligt: </span>
              <a href="https://tic.io/allmanna-villkor" target="_blank" rel="noreferrer">tic.io/allmanna-villkor</a>
              <span style={{color: 'var(--orange-500)'}}> *</span>
            </p>
          </div>
        </> }
      </div>
      <div className={styles['button-container']}>
        <BtButton color="white" onClick={onCancel}>
          <div className={styles.text}>Avbryt</div>
        </BtButton>
        { errorMessage ?
          <BtButton color="white" onClick={() => setErrorMessage(null)}>
            <div className={styles.text}>Försök igen</div>
          </BtButton>
        :
          <BtButton onClick={onSubmit}>
            <div className={styles.text}>Starta abonnemang</div>
          </BtButton>
        }
      </div>
    </div>
  )
}
